/**
 * Client-side admin allowlist (UX only — badge/button).
 * Cloud Functions still enforce ADMIN_UIDS; this never grants API power alone.
 */
const raw = String(import.meta.env.VITE_ADMIN_UIDS || "");

export const CLIENT_ADMIN_UIDS: ReadonlySet<string> = new Set(
  raw
    .split(/[,;\s]+/)
    .map((s) => s.trim())
    .filter(Boolean),
);

export function isAllowlistedAdminUid(uid: string | null | undefined): boolean {
  return Boolean(uid && CLIENT_ADMIN_UIDS.has(uid));
}
